export default "__VITE_ASSET__Dxow1M_A__"